import { FormattedMessage, useIntl } from 'react-intl'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { formatSaleUnitCount } from 'hooks/useSaleUnitFormatting'

interface Props {
  rooms?: Array<App.RoomOccupants>
  isFlightEnabled: boolean
  duration: number
  shouldDisplayRoom: boolean
  shouldDisplayFlight?: boolean
  saleUnit: string
}

function MobileMultipleRoomsDurationLabel(props: Props) {
  const {
    rooms,
    isFlightEnabled,
    duration,
    shouldDisplayRoom = false,
    shouldDisplayFlight = true,
    saleUnit,
  } = props
  const intl = useIntl()
  const roomCount = rooms?.length || 0

  const roomCountText = formatSaleUnitCount(intl, saleUnit, roomCount)

  let resultText: string
  if (shouldDisplayRoom && isFlightEnabled) {
    resultText = intl.formatMessage(
      {
        id: 'kEfYudslEwWjjn7b8syd',
        defaultMessage: '{duration, plural, one {# night} other {# nights}}, {roomCountText} + flights from',
      },
      { duration, roomCountText },
    )
  } else if (shouldDisplayRoom) {
    resultText = intl.formatMessage(
      {
        id: '5uXu2rStDOh-_a_qjyMM',
        defaultMessage: '{duration, plural, one {# night} other {# nights}}, {roomCountText} from',
      },
      { duration, roomCountText },
    )
  } else if (isFlightEnabled) {
    resultText = intl.formatMessage(
      {
        id: 'WGGCx18IsjVZ-bLOBwjg',
        defaultMessage: '{duration, plural, one {# night} other {# nights}} + flights from',
      },
      { duration },
    )
  } else {
    resultText = intl.formatMessage(
      {
        id: 'yMl05aTShZrdAZ0oMwpZ',
        defaultMessage: '{duration, plural, one {# night} other {# nights}} from',
      },
      { duration },
    )
  }

  return <>
    {isFlightEnabled && shouldDisplayFlight && <FormattedMessage
      id="Uc2-qoqVj_0oeLJKYkQ7"
      defaultMessage="{icon} {resultText}"
      
      values={{
        icon: <LinePlaneDepartureIcon />,
        resultText,
      }}
    />}
    {!isFlightEnabled && <>{resultText}</>}
  </>
}

export default withOfferPageAndReduxState((state, _) => ({
  duration: state.duration,
  rooms: state.rooms,
  isFlightEnabled: state.flights,
  saleUnit: state.offer?.saleUnit || 'room',
}), MobileMultipleRoomsDurationLabel)
